import { State } from "@/store/modules/space/index";
import {
  SpaceInterface,
  SpaceMinInfoInterface,
} from "@/resources/interfaces/spaceInterfaces";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";

const getSpace = (state: State): SpaceInterface | null => {
  return state.space;
};

const getSelectedSpaceCustomize = (state: State): SpaceInterface | null => {
  return state.selectedSpaceCustomize;
};

const getSpacesAvailable = (
  state: State
): Array<SpaceMinInfoInterface> | [] => {
  return state.spacesAvailable;
};

const getUsersInSpace = (state: State): Array<SpaceUserInterface> => {
  return state.usersInSpace;
};

const getSceneTypes = (state: State) => {
  return state.sceneTypes;
};

const getLastPage = (state: State) => {
  return state.lastPage;
};

const getUsersInSpacePage = (state: State) => {
  return state.usersInSpacePage;
};

const getUsersInDraw = (state: State) => {
  return state.usersInDraw;
};
const getTotalUsersInSpace = (state: State) => {
  return state.totalUsersInSpace;
};
const getAllUsers = (state: State) => {
  return state.allUsers;
};
const getLastPageSpaces = (state: State) => {
  return state.lastPageSpaces;
};
const getSpacesAvailablePage = (state: State) => {
  return state.spacesAvailablePage;
};
const getFavouriteSpaces = (state: State) => {
  return state.favouriteSpaces;
};
const getSuperSpace = (state: State) => {
  return state.superSpace;
};
const getConnectedSuperSpaceIds = (state: State): any[] | [] => {
  return state.connectedSuperSpaceIds;
};
const getConnectedUsersCounter = (state: State) => {
  return state.connectedUsersCounter;
};
export default {
  getSpace,
  getSpacesAvailable,
  getUsersInSpace,
  getSceneTypes,
  getLastPage,
  getUsersInSpacePage,
  getAllUsers,
  getLastPageSpaces,
  getSpacesAvailablePage,
  getTotalUsersInSpace,
  getUsersInDraw,
  getFavouriteSpaces,
  getSelectedSpaceCustomize,
  getSuperSpace,
  getConnectedSuperSpaceIds,
  getConnectedUsersCounter,
};
